export default {
      id: "i-chart-usage",
      viewBox: "0 0 93 71",
      url: __webpack_public_path__ + "img/sprite.svg#i-chart",
      toString: function () {
        return this.url;
      }
    }